import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {TagUserComponent} from './tag-user.component';
import {SharedModule} from '../../modules/shared/shared.module';

@NgModule({
  declarations: [
    TagUserComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    IonicModule,
    TranslatePipe,
    TranslateDirective,
    SharedModule
  ],
  exports: [
    TagUserComponent,
  ]
})
export class TagUserModule {
}
